import React, { memo } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Radio } from 'redpoints-front-components/index';
import { withContext } from 'redpoints-front-common/components';

import {
  testPurchaseFetchDomains,
  testPurchaseSetFiltersSelected,
} from '../../../actions/testPurchaseActions';
import { getTestPurchaseFiltersSelected } from '../../../reducers/tasks/testPurchase';
import FilterByEnum from '../../../enumerations/FilterBy';
import { translate } from '../../../helpers/languageHelper';
import { getContextDataFromFilterBy } from './testPurchaseFiltersHelpers';

import './testPurchaseFilterBy.less';

const TestPurchaseFilterBy = ({
  context,
  customer: {
    name: customerName,
    tenant: { name: tenantName },
  },
  contract: { name: contractName },
  filtersSelected: { domainId, domainPlatformId, filterBy },
  isEnableFilterByTenant,
  testPurchaseSetFiltersSelected,
  testPurchaseFetchDomains,
}) => {
  const label = translate('tasks.testPurchase.filter.filterBy.label');
  const filterByContractLabel = `${translate(
    'tasks.testPurchase.filter.filterBy.filterByContractLabel'
  )} (${contractName})`;
  const filterByCustomerLabel = `${translate(
    'tasks.testPurchase.filter.filterBy.filterByCustomerLabel'
  )} (${customerName})`;
  const filterByAllCustomersLabel = `${translate(
    'tasks.testPurchase.filter.filterBy.filterByAllCustomersLabel'
  )} (${tenantName})`;

  const handleChangeFilterBy = ({ target: { value } }) => {
    const { customerId, contractId } = getContextDataFromFilterBy(
      value,
      context
    );

    testPurchaseFetchDomains({
      customerId,
      contractId,
    });

    testPurchaseSetFiltersSelected({
      domainId,
      domainPlatformId,
      filterBy: value,
    });
  };

  return (
    <Radio
      className="test-purchase-filter-context"
      data={[
        {
          value: FilterByEnum.CONTRACT.name,
          text: `${filterByCustomerLabel} ${filterByContractLabel}`,
        },
        {
          value: FilterByEnum.CUSTOMER.name,
          text: filterByCustomerLabel,
        },
        {
          disabled: !isEnableFilterByTenant,
          value: FilterByEnum.TENANT.name,
          text: filterByAllCustomersLabel,
        },
      ]}
      value={filterBy}
      label={label}
      onChange={handleChangeFilterBy}
      vertical
    />
  );
};

const mapStateToProps = state => ({
  filtersSelected: getTestPurchaseFiltersSelected(state),
});

export default compose(
  withContext,
  connect(mapStateToProps, {
    testPurchaseSetFiltersSelected,
    testPurchaseFetchDomains,
  }),
  memo
)(TestPurchaseFilterBy);
